import type { AxiosInstance } from 'axios'
import type { IFactoryFunctionRequest } from '@bc-library/interface'
import { EMethod } from '@bc-library/interface'
import { API_MAIN_VERSION, BASE_URL } from '@/config/constantes'
import useAxios from '@/services/api/useAxios'

const resource = 'invoicingTerms'

const showFirm = (axios: IFactoryFunctionRequest<Array<any>, undefined>) => () => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/firm`,
  })
}

const filter = (axios: IFactoryFunctionRequest<Array<any>, undefined>) => ({
  page = 0,
  display = '',
  limit = 20,
}: { page?: number; display?: string; limit?: number } = {}) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/filter`,
    query: { page, display, limit },
  })
}

const createInvoicingTerm = (axios: IFactoryFunctionRequest<any, any>) => (data) => {
  return axios({
    method: EMethod.post,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/create`,
    data,
  })
}

const updateInvoicingTerm = (axios: IFactoryFunctionRequest<any, any>) => (id, { data }) => {
  return axios({
    method: EMethod.patch,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/update/${id}`,
    data,
  })
}

const deleteInvoicingTerm = (axios: IFactoryFunctionRequest<any, any>) => (id: string) => {
  return axios({
    method: EMethod.delete,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/delete/${id}`,
  })
}

export default (axios: AxiosInstance) => ({
  showFirm: showFirm(useAxios(axios)),
  filter: filter(useAxios(axios)),
  create: createInvoicingTerm(useAxios(axios)),
  update: updateInvoicingTerm(useAxios(axios)),
  delete: deleteInvoicingTerm(useAxios(axios)),
})
